module.exports = __webpack_public_path__ + "img/water_tank_storage.07948b20.svg";